// import React, { useEffect } from "react";
// import { motion } from "framer-motion";

// import {
//   Clock3,
//   Wallet,
//   Plane,
//   TrendingUp,
//   Receipt,
//   Users,
//   ArrowRight,
// } from "lucide-react";

// import "../styles/Features.css";

// const featuresData = [
//   {
//     number: "01",
//     title: "Attendance Management",
//     description:
//       "Track employee attendance, shifts, punch-ins, and working hours instantly.",
//     icon: <Clock3 size={34} />,
//   },

//  {
//   number: "02",
//   title: "Payroll & Employee Documents",
//   description:
//     "Manage monthly salary documents, payslips, payroll records, appraisal letters, experience letters, relieving letters, and other employee HR documents from one centralized module.",
//   icon: <Wallet size={34} />,
// },

//   {
//     number: "03",
//     title: "Leave Management",
//     description:
//       "Manage leave approvals, balances, requests, and holiday calendars easily.",
//     icon: <Plane size={34} />,
//   },

//   {
//     number: "04",
//     title: "Performance Tracking",
//     description:
//       "Monitor goals, OKR's, reviews, and employee performance analytics.",
//     icon: <TrendingUp size={34} />,
//   },

//   {
//     number: "05",
//     title: "Reimbursements",
//     description:
//       "Simplify reimbursement approvals, expense tracking, and claim processing.",
//     icon: <Receipt size={34} />,
//   },

//   {
//     number: "06",
//     title: "Employee Self Service",
//     description:
//       "Employees can manage profiles, requests, documents, and workflows.",
//     icon: <Users size={34} />,
//   },
// ];

// const leftFeatures = featuresData.slice(0, 3);
// const rightFeatures = featuresData.slice(3, 6);

// const FeaturesSection = () => {
//   useEffect(() => {
//     const existingScript = document.querySelector(
//       'script[src="https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js"]'
//     );

//     const initSpline = () => {
//       const interval = setInterval(() => {
//         const splineViewer = document.getElementById("mySpline");

//         if (splineViewer && splineViewer.shadowRoot) {
//           const style = document.createElement("style");

//           style.textContent = `
//           #logo,
//           a[part="logo"],
//           div[class*="logo"] {
//             display: none !important;
//             opacity: 0 !important;
//             visibility: hidden !important;
//           }
//         `;

//           splineViewer.shadowRoot.appendChild(style);

//           clearInterval(interval);
//         }
//       }, 10);
//     };

//     if (!existingScript) {
//       const script = document.createElement("script");

//       script.type = "module";

//       script.src =
//         "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//       script.onload = initSpline;

//       document.body.appendChild(script);
//     } else {
//       initSpline();
//     }
//   }, []);


//   return (
//     <section className="website-features-section">
//       {/* GLOW EFFECTS */}

//       <div className="features-glow features-glow-1"></div>
//       <div className="features-glow features-glow-2"></div>

//       {/* HEADER */}

//       <motion.div
//         className="website-section-header"
//         initial={{ opacity: 0, y: 60 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.8 }}
//         viewport={{ once: true }}
//       >


//         <h2 className="website-section-title">
//           Advanced <span>Features</span> at Work
//         </h2> 

//         <p className="website-section-description">
//           Intelligent automation. Smarter workforce management.
//           Better employee experience.
//         </p>
//       </motion.div>

//       {/* MAIN */}

//       <div className="robot-features-layout">
//         {/* LEFT */}

//         <div className="features-column left-column">
//           {leftFeatures.map((feature, index) => (
//             <motion.div
//               className="website-feature-card"
//               key={index}
//               initial={{ opacity: 0, x: -100 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{
//                 duration: 0.7,
//                 delay: index * 0.15,
//               }}
//               viewport={{ once: true }}
//             >
//               <div className="card-inner">
//                 <div className="website-feature-icon">
//                   {feature.icon}
//                 </div>

//                 <div className="feature-content">
//                   <span className="feature-number">
//                     {feature.number}
//                   </span>

//                   <h3>{feature.title}</h3>

//                   <p>{feature.description}</p>
//                 </div>

//               </div>
//             </motion.div>
//           ))}
//         </div>

//         {/* ROBOT */}

//         <motion.div
//           className="robot-center"
//           initial={{ opacity: 0, scale: 0.8 }}
//           whileInView={{ opacity: 1, scale: 1.5}}
//           transition={{ duration: 1 }}
//           viewport={{ once: true }}
//         >
//           <div className="robot-rings"></div>

//           <spline-viewer
//             id="mySpline"
//             url="https://prod.spline.design/sIJs7lCl4C8uSfk2/scene.splinecode"
//           ></spline-viewer>
//         </motion.div>

//         {/* RIGHT */}

//         <div className="features-column right-column">
//           {rightFeatures.map((feature, index) => (
//             <motion.div
//               className="website-feature-card"
//               key={index}
//               initial={{ opacity: 0, x: 100 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{
//                 duration: 0.7,
//                 delay: index * 0.15,
//               }}
//               viewport={{ once: true }}
//             >
//               <div className="card-inner">
//                 <div className="website-feature-icon">
//                   {feature.icon}
//                 </div>

//                 <div className="feature-content">
//                   <span className="feature-number">
//                     {feature.number}
//                   </span>

//                   <h3>{feature.title}</h3>

//                   <p>{feature.description}</p>
//                 </div>


//               </div>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeaturesSection;















// import React, { useEffect } from "react";
// import { motion } from "framer-motion";
// import {
//   Clock3,
//   Wallet,
//   Plane,
//   TrendingUp,
//   Receipt,
//   Users,
//   ArrowRight,
// } from "lucide-react";
// import "../styles/Features.css";

// const featuresData = [
//   { title: "Attendance Management", description: "Track employee attendance, shifts, punch-ins, and working hours in real-time.", icon: <Clock3 size={24} /> },
//   { title: "Payroll Processing", description: "Manage monthly salary documents, payslips, payroll records, appraisal letters, experience letters, relieving letters, and other employee HR documents from one centralized module.", icon: <Wallet size={24} /> },
//   { title: "Leave Management", description: "Manage leave requests, approvals, balances, and holiday calendars seamlessly.", icon: <Plane size={24} /> },
//   { title: "Performance Tracking", description: "Monitor KRAs, goals, reviews, and employee performance analytics efficiently.", icon: <TrendingUp size={24} /> },
//   { title: "Reimbursements", description: "Simplify reimbursement approvals, expense tracking, and claim processing.", icon: <Receipt size={24} /> },
//   { title: "Employee Self Service", description: "Empower employees to manage profiles, requests, documents, and workflows.", icon: <Users size={24} /> },
// ];

// const leftFeatures = featuresData.slice(0, 3);
// const rightFeatures = featuresData.slice(3, 6);

// const FeaturesSection = () => {
//  useEffect(() => {
//   const scriptSrc =
//     "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//   if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
//     const script = document.createElement("script");
//     script.type = "module";
//     script.src = scriptSrc;
//     document.body.appendChild(script);
//   }

//   const interval = setInterval(() => {
//     const viewer = document.querySelector("spline-viewer");

//     if (!viewer || !viewer.shadowRoot) return;

//     if (!viewer.shadowRoot.querySelector("#hide-spline-watermark")) {
//       const style = document.createElement("style");
//       style.id = "hide-spline-watermark";
//       style.textContent = `
//         a[href*="spline.design"],
//         a[href*="spline"],
//         #logo,
//         [part="logo"] {
//           display: none !important;
//           visibility: hidden !important;
//           opacity: 0 !important;
//           pointer-events: none !important;
//         }
//       `;
//       viewer.shadowRoot.appendChild(style);
//     }
//   }, 100);

//   return () => clearInterval(interval);
// }, []);
//   const renderCard = (feature, index, side) => (
//     <motion.div
//       className="website-feature-card"
//       key={index}
//       initial={{ opacity: 0, x: side === "left" ? -50 : 50 }}
//       whileInView={{ opacity: 1, x: 0 }}
//       transition={{ duration: 0.6, delay: index * 0.1 }}
//       viewport={{ once: true }}
//     >
//       <div className="card-number">{String(index + (side === "right" ? 4 : 1)).padStart(2, '0')}</div>
//       <div className="card-content-wrapper">
//         <div className="website-feature-icon">{feature.icon}</div>
//         <div className="text-content">
//           <h3>{feature.title} <span className="ai-tag"></span></h3>
//           <p>{feature.description}</p>
//         </div>
//         {/* <div className="feature-arrow">
//           <ArrowRight size={18} />
//         </div> */}
//       </div>
//     </motion.div>
//   );

//   return (
//     <section className="website-features-section">
//       <div className="bg-overlay"></div>

//       <motion.div 
//         className="website-section-header"
//         initial={{ opacity: 0, y: 30 }}
//         whileInView={{ opacity: 1, y: 0 }}
//       >
//         <p className="website-section-mini-title">AI POWERING YOUR WORKFORCE</p>
//         <h2 className="website-section-title">Advanced <span>Features</span> at Work</h2>
//         <p className="website-section-description">Intelligent automation. Smarter decisions. Better hires.</p>
//       </motion.div>

//       <div className="robot-features-layout">
//         <div className="features-column left-column">
//           {leftFeatures.map((f, i) => renderCard(f, i, "left"))}
//         </div>

//         <div className="robot-center">
//           <spline-viewer url="https://prod.spline.design/sIJs7lCl4C8uSfk2/scene.splinecode"></spline-viewer>
//         </div>

//         <div className="features-column right-column">
//           {rightFeatures.map((f, i) => renderCard(f, i, "right"))}
//         </div>
//       </div>


//     </section>
//   );
// };

// export default FeaturesSection;











// import React, { useEffect } from "react";
// import {
//   Clock3,
//   Wallet,
//   Plane,
//   TrendingUp,
//   Receipt,
//   Users,
// } from "lucide-react";
// import "../styles/Features.css";

// const featuresData = [
//   {
//     title: "Attendance Management",
//     description:
//       "Track employee attendance, shifts, punch-ins, and working hours in real-time.",
//     icon: <Clock3 size={24} />,
//   },
//   {
//     title: "Payroll Processing",
//     description:
//       "Manage monthly salary documents, payslips, and HR documents from one centralized module.",
//     icon: <Wallet size={24} />,
//   },
//   {
//     title: "Leave Management",
//     description:
//       "Manage leave requests, approvals, balances, and holiday calendars seamlessly.",
//     icon: <Plane size={24} />,
//   },

//   {
//     title: "Performance Tracking",
//     description:
//       "Monitor KRAs, goals, reviews, and employee performance analytics efficiently.",
//     icon: <TrendingUp size={24} />,
//   },
//   {
//     title: "Reimbursements",
//     description:
//       "Simplify reimbursement approvals, expense tracking, and claim processing.",
//     icon: <Receipt size={24} />,
//   },
//   {
//     title: "Employee Self Service",
//     description:
//       "Empower employees to manage profiles, requests, documents, and workflows.",
//     icon: <Users size={24} />,
//   },
// ];

// const FeaturesSection = () => {
//   useEffect(() => {
//     const scriptSrc =
//       "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//     if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
//       const script = document.createElement("script");
//       script.type = "module";
//       script.src = scriptSrc;
//       document.body.appendChild(script);
//     }

//     const interval = setInterval(() => {
//       const viewer = document.querySelector("spline-viewer");

//       if (
//         viewer?.shadowRoot &&
//         !viewer.shadowRoot.querySelector("#hide-spline-watermark")
//       ) {
//         const style = document.createElement("style");
//         style.id = "hide-spline-watermark";
//         style.textContent = `
//           a[href*="spline.design"],
//           #logo {
//             display: none !important;
//           }
//         `;
//         viewer.shadowRoot.appendChild(style);
//       }
//     }, 500);

//     return () => clearInterval(interval);
//   }, []);

//   const renderCard = (feature, index, side) => (
//     <div className="website-feature-card" key={index}>
//       <div className="card-number">
//         {String(index + (side === "right" ? 4 : 1)).padStart(2, "0")}
//       </div>

//       <div className="card-content-wrapper">
//         <div className="website-feature-icon">{feature.icon}</div>

//         <div className="text-content">
//           <h3>{feature.title}</h3>
//           <p>{feature.description}</p>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <section className="website-features-section">
//       <div className="bg-overlay"></div>

//       <div className="website-section-header">
//         <p className="website-section-mini-title">AI POWERING YOUR WORKFORCE</p>
//         <h2 className="website-section-title">
//           Advanced <span>Features</span> at Work
//         </h2>
//       </div>

//       <div className="robot-features-layout">
//         <div className="features-column left-column">
//           {featuresData.slice(0, 3).map((f, i) => renderCard(f, i, "left"))}
//         </div>

//         <div
//           className="robot-center"
//           style={{
//             position: "relative",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           {/* Hint Note */}
//           <div
//             style={{
//               position: "absolute",
//               top: "30px",
//               right: "20px",
//               background: "rgba(0,0,0,0.8)",
//               color: "#fff",
//               padding: "10px 16px",
//               borderRadius: "30px",
//               fontSize: "14px",
//               fontWeight: "600",
//               display: "flex",
//               alignItems: "center",
//               gap: "8px",
//               zIndex: 10,
//               boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
//               animation: "floatHint 2s ease-in-out infinite",
//               cursor: "default",
//             }}
//           >
//             <span style={{ fontSize: "20px" }}>🎮</span>
//             Rotate me & play!
//           </div>

//           <div className="spline-container">
//             <spline-viewer
//               url="https://prod.spline.design/sIJs7lCl4C8uSfk2/scene.splinecode"
//               style={{
//                 width: "500px",
//                 height: "500px",
//               }}
//             ></spline-viewer>
//           </div>
//         </div>

//         <div className="features-column right-column">
//           {featuresData.slice(3, 6).map((f, i) => renderCard(f, i, "right"))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeaturesSection;






















// import React, { useEffect } from "react";
// import {
//   Clock3,
//   Wallet,
//   Plane,
//   TrendingUp,
//   Receipt,
//   Users,
//   UserCog,
//   Handshake,
// } from "lucide-react";
// import "../styles/Features.css";

// const featuresData = [
//   {
//     title: "Attendance Management",
//     description:
//       "Track employee attendance, shifts, punch-ins, and working hours in real-time.",
//     icon: <Clock3 size={24} />,
//   },
//   {
//     title: "Pay & Benefits",
//     description:
//       "Manage monthly salary documents, payslips, and HR documents from one centralized module.",
//     icon: <Wallet size={24} />,
//   },
//   {
//     title: "Leave Management",
//     description:
//       "Manage leave requests, approvals, balances, and holiday calendars seamlessly.",
//     icon: <Plane size={24} />,
//   },

//   {
//   title: "Employee Management",
//   description:
//     "Manage employee profiles, records, departments, and organizational information from a centralized platform.",
//      icon: <UserCog size={24} />,
// },


// {
//   title: "One-on-One Meetings",
//   description:
//     "Plan meetings, assign tasks, record discussion notes, and notify employees of missed sessions through automated emails.",
//       icon: <Handshake size={24} />,
// },
//   {
//     title: "Performance Tracking",
//     description:
//       "Monitor OKR's, goals, reviews, and employee performance analytics efficiently.",
//     icon: <TrendingUp size={24} />,
//   },
//   {
//     title: "Reimbursements",
//     description:
//       "Simplify reimbursement approvals, expense tracking, and claim processing.",
//     icon: <Receipt size={24} />,
//   },
//   {
//     title: "Employee Self Service",
//     description:
//       "Empower employees to manage profiles, requests, documents, and workflows.",
//     icon: <Users size={24} />,
//   },
// ];

// const FeaturesSection = () => {
//   useEffect(() => {
//     const scriptSrc =
//       "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//     if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
//       const script = document.createElement("script");
//       script.type = "module";
//       script.src = scriptSrc;
//       document.body.appendChild(script);
//     }

//     const interval = setInterval(() => {
//       const viewer = document.querySelector("spline-viewer");

//       if (
//         viewer?.shadowRoot &&
//         !viewer.shadowRoot.querySelector("#hide-spline-watermark")
//       ) {
//         const style = document.createElement("style");
//         style.id = "hide-spline-watermark";
//         style.textContent = `
//           a[href*="spline.design"],
//           #logo {
//             display: none !important;
//           }
//         `;
//         viewer.shadowRoot.appendChild(style);
//       }
//     }, 500);

//     return () => clearInterval(interval);
//   }, []);

//   const renderCard = (feature, index, side) => (
//     <div className="website-feature-card" key={index}>
//       <div className="card-number">
//        {String(index + (side === "right" ? 5 : 1)).padStart(2, "0")}
//       </div>

//       <div className="card-content-wrapper">
//         <div className="website-feature-icon">{feature.icon}</div>

//         <div className="text-content">
//           <h3>{feature.title}</h3>
//           <p>{feature.description}</p>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <section className="website-features-section">
//       <div className="bg-overlay"></div>

//       <div className="website-section-header">
//         <p className="website-section-mini-title">AI POWERING YOUR WORKFORCE</p>
//         <h2 className="website-section-title">
//           Advanced <span>Features</span> at Work
//         </h2>
//       </div>

//       <div className="robot-features-layout">
//         <div className="features-column left-column">
//           {featuresData.slice(0, 4).map((f, i) => renderCard(f, i, "left"))}
//         </div>

//         <div
//           className="robot-center"
//           style={{
//             position: "relative",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           {/* Hint Note */}
//           <div
//             style={{
//               position: "absolute",
//               top: "30px",
//               right: "20px",
//               background: "rgba(0,0,0,0.8)",
//               color: "#fff",
//               padding: "10px 16px",
//               borderRadius: "30px",
//               fontSize: "14px",
//               fontWeight: "600",
//               display: "flex",
//               alignItems: "center",
//               gap: "8px",
//               zIndex: 10,
//               boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
//               animation: "floatHint 2s ease-in-out infinite",
//               cursor: "default",
//             }}
//           >
//             <span style={{ fontSize: "20px" }}>🎮</span>
//             Rotate me & play!
//           </div>

//           <div className="spline-container">
//             <spline-viewer
//               url="https://prod.spline.design/sIJs7lCl4C8uSfk2/scene.splinecode"
//               style={{
//                 width: "500px",
//                 height: "500px",
//               }}
//             ></spline-viewer>
//           </div>
//         </div>

//         <div className="features-column right-column">
//           {featuresData.slice(4, 8).map((f, i) => renderCard(f, i, "right"))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeaturesSection;

























// import React, { useEffect } from "react";
// import {
//   Clock3,
//   Wallet,
//   Plane,
//   TrendingUp,
//   Receipt,
//   Users,
//   UserCog,
//   Handshake,
// } from "lucide-react";

// import { useNavigate } from "react-router-dom";
// import "../styles/Features.css";

// const featuresData = [
//   {
//     title: "Attendance Management",
//     description:
//       "Track employee attendance, shifts, punch-ins, and working hours in real-time.",
//     icon: <Clock3 size={24} />,
//   },
//   {
//     title: "Pay & Benefits",
//     description:
//       "Manage monthly salary documents, payslips, and HR documents from one centralized module.",
//     icon: <Wallet size={24} />,
//   },
//   {
//     title: "Leave Management",
//     description:
//       "Manage leave requests, approvals, balances, and holiday calendars seamlessly.",
//     icon: <Plane size={24} />,
//   },

//   {
//   title: "Employee Management",
//   description:
//     "Manage employee profiles, records, departments, and organizational information from a centralized platform.",
//      icon: <UserCog size={24} />,
// },


// {
//   title: "One-on-One Meetings",
//   description:
//     "Plan meetings, assign tasks, record discussion notes, and notify employees of missed sessions through automated emails.",
//       icon: <Handshake size={24} />,
// },
//   {
//     title: "Performance Tracking",
//     description:
//       "Monitor OKR's, goals, reviews, and employee performance analytics efficiently.",
//     icon: <TrendingUp size={24} />,
//   },
//   {
//     title: "Reimbursements",
//     description:
//       "Simplify reimbursement approvals, expense tracking, and claim processing.",
//     icon: <Receipt size={24} />,
//   },
//   {
//     title: "Employee Self Service",
//     description:
//       "Empower employees to manage profiles, requests, documents, and workflows.",
//     icon: <Users size={24} />,
//   },
// ];

// const FeaturesSection = () => {

//   const navigate = useNavigate();
//   useEffect(() => {
//     const scriptSrc =
//       "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//     if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
//       const script = document.createElement("script");
//       script.type = "module";
//       script.src = scriptSrc;
//       document.body.appendChild(script);
//     }

//     const interval = setInterval(() => {
//       const viewer = document.querySelector("spline-viewer");

//       if (
//         viewer?.shadowRoot &&
//         !viewer.shadowRoot.querySelector("#hide-spline-watermark")
//       ) {
//         const style = document.createElement("style");
//         style.id = "hide-spline-watermark";
//         style.textContent = `
//           a[href*="spline.design"],
//           #logo {
//             display: none !important;
//           }
//         `;
//         viewer.shadowRoot.appendChild(style);
//       }
//     }, 500);

//     return () => clearInterval(interval);
//   }, []);

//   const renderCard = (feature, index, side) => (
//     <div className="website-feature-card" key={index}>
//       <div className="card-number">
//        {String(index + (side === "right" ? 5 : 1)).padStart(2, "0")}
//       </div>

//       <div className="card-content-wrapper">
//         <div className="website-feature-icon">{feature.icon}</div>

//         <div className="text-content">
//           <h3>{feature.title}</h3>
//           <p>{feature.description}</p>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <section className="website-features-section">
//       <div className="mobile-back-btn">
//   <button onClick={() => navigate("/")}>
//     ← Back Home
//   </button>
// </div>
//       <div className="bg-overlay"></div>

//       <div className="website-section-header">
//         <p className="website-section-mini-title">AI POWERING YOUR WORKFORCE</p>
//         <h2 className="website-section-title">
//           Advanced <span>Features</span> at Work
//         </h2>
//       </div>

//       <div className="robot-features-layout">
//         <div className="features-column left-column">
//           {featuresData.slice(0, 4).map((f, i) => renderCard(f, i, "left"))}
//         </div>

//         <div
//           className="robot-center"
//           style={{
//             position: "relative",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           {/* Hint Note */}
//           <div
//             style={{
//               position: "absolute",
//               top: "30px",
//               right: "20px",
//               background: "rgba(0,0,0,0.8)",
//               color: "#fff",
//               padding: "10px 16px",
//               borderRadius: "30px",
//               fontSize: "14px",
//               fontWeight: "600",
//               display: "flex",
//               alignItems: "center",
//               gap: "8px",
//               zIndex: 10,
//               boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
//               animation: "floatHint 2s ease-in-out infinite",
//               cursor: "default",
//             }}
//           >
//             <span style={{ fontSize: "20px" }}>🎮</span>
//             Rotate me & play!
//           </div>

//           <div className="spline-container">
//             <spline-viewer
//               url="https://prod.spline.design/sIJs7lCl4C8uSfk2/scene.splinecode"
//               style={{
//                 width: "500px",
//                 height: "500px",
//               }}
//             ></spline-viewer>
//           </div>
//         </div>

//         <div className="features-column right-column">
//           {featuresData.slice(4, 8).map((f, i) => renderCard(f, i, "right"))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeaturesSection;

















import React, { useEffect } from "react";
import {
  Clock3,
  Wallet,
  Plane,
  TrendingUp,
  Receipt,
  Users,
  UserCog,
  Handshake,
} from "lucide-react";

import { useNavigate } from "react-router-dom";
import "../styles/Features.css";

const featuresData = [
  {
    title: "GTELINQ HRMS",
    description:
      "A complete human resource management platform for attendance, leave, employee records, performance, and workforce management.",
    icon: <Users size={24} />,
  },
  {
    title: "Hiring Hub",
    description:
      "Simplify recruitment with job postings, applicant tracking, interview scheduling, and candidate management.",
    icon: <UserCog size={24} />,
  },
  {
    title: "Payroll",
    description:
      "Automate salary processing, payslips, statutory compliance, reimbursements, and employee compensation.",
    icon: <Wallet size={24} />,
  },
  {
    title: "CRM",
    description:
      "Manage leads, customers, sales pipelines, follow-ups, and business relationships from one intelligent platform.",
    icon: <Handshake size={24} />,
  },
  {
    title: "Inventory Management",
    description:
      "Track inventory levels, stock movement, product availability, and warehouse inventory in real time.",
    icon: <Receipt size={24} />,
  },
  {
    title: "Purchase & Procurement",
    description:
      "Manage purchase requests, vendor approvals, purchase orders, and procurement workflows efficiently.",
    icon: <TrendingUp size={24} />,
  },
  {
    title: "Warehouse Management",
    description:
      "Optimize warehouse operations with inventory tracking, barcode support, storage management, and dispatch control.",
    icon: <Clock3 size={24} />,
  },
  {
    title: "Integrated Platform",
    description:
      "All Genesis Tech enterprise solutions work together seamlessly, giving your organization one connected business ecosystem.",
    icon: <Plane size={24} />,
  },
];

const FeaturesSection = () => {

  const navigate = useNavigate();
  useEffect(() => {
    const scriptSrc =
      "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement("script");
      script.type = "module";
      script.src = scriptSrc;
      document.body.appendChild(script);
    }

    const interval = setInterval(() => {
      const viewer = document.querySelector("spline-viewer");

      if (
        viewer?.shadowRoot &&
        !viewer.shadowRoot.querySelector("#hide-spline-watermark")
      ) {
        const style = document.createElement("style");
        style.id = "hide-spline-watermark";
        style.textContent = `
          a[href*="spline.design"],
          #logo {
            display: none !important;
          }
        `;
        viewer.shadowRoot.appendChild(style);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const renderCard = (feature, index, side) => (
    <div className="website-feature-card" key={index}>
      <div className="card-number">
        {String(index + (side === "right" ? 5 : 1)).padStart(2, "0")}
      </div>

      <div className="card-content-wrapper">
        <div className="website-feature-icon">{feature.icon}</div>

        <div className="text-content">
          <h3>{feature.title}</h3>
          <p>{feature.description}</p>
        </div>
      </div>
    </div>
  );

  return (
    <section className="website-features-section">
      <div className="mobile-back-btn">
        <button onClick={() => navigate("/")}>
          ← Back Home
        </button>
      </div>
      <div className="bg-overlay"></div>

      <div className="website-section-header">
        <p className="website-section-mini-title">
          OUR ENTERPRISE SOLUTIONS
        </p>

       <h2 className="website-section-title">
  Complete Enterprise
  <br />
  <span>Software Suite</span>
</h2>
      </div>

      <div className="robot-features-layout">
        <div className="features-column left-column">
          {featuresData.slice(0, 4).map((f, i) => renderCard(f, i, "left"))}
        </div>

        <div
          className="robot-center"
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Hint Note */}
          <div
            style={{
              position: "absolute",
              top: "30px",
              right: "20px",
              background: "rgba(0,0,0,0.8)",
              color: "#fff",
              padding: "10px 16px",
              borderRadius: "30px",
              fontSize: "14px",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              zIndex: 10,
              boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
              animation: "floatHint 2s ease-in-out infinite",
              cursor: "default",
            }}
          >
            <span style={{ fontSize: "20px" }}>🎮</span>
            Rotate me & play!
          </div>

          <div className="spline-container">
            <spline-viewer
              url="https://prod.spline.design/sIJs7lCl4C8uSfk2/scene.splinecode"
              style={{
                width: "500px",
                height: "500px",
              }}
            ></spline-viewer>
          </div>
        </div>

        <div className="features-column right-column">
          {featuresData.slice(4, 8).map((f, i) => renderCard(f, i, "right"))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;










